import React from 'react'

import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/styles'
import { useLocale, useSetLocale } from 'react-admin'

import tracker from '../../utils/tracker'

const useStyles = makeStyles((theme) => ({
  button: {
    ...theme.mundi.font.roboto900Normal,
  },
}))

const Action = (props) => {
  const classes = useStyles()
  const locale = useLocale()
  const setLocale = useSetLocale()
  const switchToSpanish = () => {
    setLocale('es')
    tracker.event({
      action: 'language_button_selected',
      category: 'language',
      label: 'es',
    })
  }
  const switchToEnglish = () => {
    setLocale('en')
    tracker.event({
      action: 'language_button_selected',
      category: 'language',
      label: 'en',
    })
  }

  return (
    <div {...props}>
      {locale === 'en' && (
        <Button
          className={`${props.className} ${classes.button}`}
          onClick={switchToSpanish}
        >
          es
        </Button>
      )}
      {locale === 'es' && (
        <Button
          className={`${props.className} ${classes.button}`}
          onClick={switchToEnglish}
        >
          en
        </Button>
      )}
    </div>
  )
}

export default Action
